import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { LocaleProvider } from "@/lib/locale";
import Home from "@/pages/Home";
import TitleDetail from "@/pages/TitleDetail";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Messages from "@/pages/Messages";
import MessageThread from "@/pages/MessageThread";
import AuthCallback from "@/pages/AuthCallback";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import Friends from "@/pages/Friends";
import Critics from "@/pages/Critics";
import UserProfile from "@/pages/UserProfile";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/title/:id" element={<TitleDetail />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/u/:user_id" element={<UserProfile />} />
      <Route path="/messages" element={<Messages />} />
      <Route path="/messages/:user_id" element={<MessageThread />} />
      <Route path="/friends" element={<Friends />} />
      <Route path="/critics" element={<Critics />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LocaleProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster theme="dark" position="bottom-right" />
          </AuthProvider>
        </LocaleProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
